// vim: set ts=2 sw=2 et ft=javascript:
/*
 * Copyright (C) 2014 Minted Inc.
 *
 * All Rights Reserved
 */

(function (M, Backbone, $, _) {
  "use strict";

  M.View = M.View || {};
  M.View.Order = M.View.Order || {};

  M.View.Order.OrderStatus = Backbone.View.extend({
    template: M.Template.Base.StatusNotifications,
    currentOrderIndex: 0,
    maxOrderIndex: 0,

    // Time it takes for an order to fade out/fade in (in ms).
    ORDER_FADE_TIME: 400,

    // Animation time for the bar to slide down on render.
    SLIDE_ANIMATION_TIME: 400,

    events: {
      'click .leftArrow.active': 'switchOrderLeft',
      'click .rightArrow.active': 'switchOrderRight',
      'click .notificationButton': 'buttonClickEvt',
      'click .orderDetailsLink': 'orderLinkClickEvt'
    },

    initialize: function() {
      this.$el = $(this.el);
      this.model.bind('change', this.render.bind(this));
    },

    // Renders the OrderStatus view using data from its model.
    render: function() {
      var html = '';
      if (this.model.isUserLoggedIn() && this.$el.length) {
        var renderData = this.model.get('data');
        if (renderData.length) {
          html = this.template({
            data: renderData,
            shouldRenderVisitorVersion: this.model.isKnownVisitor() &&
              !this.model.isLoggedInUser()
          });
          this.maxOrderIndex = renderData.length - 1;

          this.$el.html(html);

          // TODO: Inherit from M.View.NotificationBar as they both share
          // the same behavior.
          this.$el.attr('style', 'display: none');
          _.delay(function() {
            this.$el.slideDown(this.SLIDE_ANIMATION_TIME);
          }.bind(this), this.SLIDE_ANIMATION_TIME);

          this.barShownEvt();
        }
      }
      return this;
    },

    highlightArrows: function() {
      this.$el.find('.leftArrow').addClass('active');
      this.$el.find('.rightArrow').addClass('active');

      if (this.currentOrderIndex === 0) {
        this.$el.find('.leftArrow').removeClass('active');
      } else if (this.currentOrderIndex === this.maxOrderIndex) {
        this.$el.find('.rightArrow').removeClass('active');
      }
    },

    // Animates switching between two orders in the notification bar by fading
    // out and in.
    animateOrders: function() {
      var $orders = this.$el.find('.singleOrder');

      // Fade the appropriate order in when the promise resolves.
      $orders.stop(true, true).fadeOut(this.ORDER_FADE_TIME).promise().done(
        function() {
          $($orders[this.currentOrderIndex]).fadeIn(this.ORDER_FADE_TIME);
        }.bind(this)
      );
      this.$el.find('#currentOrderNumber').html(this.currentOrderIndex + 1);
    },

    // Switches to the previous order in the notification bar.
    switchOrderLeft: function() {
      if (this.currentOrderIndex === 0) {
        return;
      }
      this.currentOrderIndex -= 1;

      this.highlightArrows();
      this.animateOrders();
    },

    // Switches to the next order in the notification bar.
    switchOrderRight: function() {
      if (this.currentOrderIndex === this.maxOrderIndex) {
        return;
      }
      this.currentOrderIndex += 1;

      this.highlightArrows();
      this.animateOrders();
    },

    // Tracks the bar shown event.
    barShownEvt: function() {
      var order = this.model.get('data')[this.currentOrderIndex];
      var GA_label = order['button_text'].replace(/\s+/g, '_');

      M.GA.trackEvent(
        M.GA.TRACK_EVENT_CATEGORY.NOTIFICATION,
        M.GA.TRACK_EVENT_ACTION.ORDER_STATUS_SHOWN,
        GA_label
      );
    },

    // Tracks button click events for analytics.
    buttonClickEvt: function() {
      var order = this.model.get('data')[this.currentOrderIndex];
      var GA_label = order['button_text'].replace(/\s+/g, '_');

      // Fire off GA/Track API Event
      var gaData = {};
      var trackData = {};
      gaData['target'] = trackData['feature'] = M.GA.TRACK_EVENT_CATEGORY.NOTIFICATION;
      gaData['action'] = trackData['event'] = M.GA.TRACK_EVENT_ACTION.ORDER_BUTTON_CLICK;
      gaData['label'] = trackData['label'] = GA_label
      trackData['order_number'] = order.po_number;

      M.sendTrackAPIAndGAEvent(gaData, trackData);

    },

    // Tracks order details link clicks for analytics.
    orderLinkClickEvt: function() {
      var order = this.model.get('data')[this.currentOrderIndex];
      var GA_label = order['button_text'].replace(/\s+/g, '_');

      M.GA.trackEvent(
        M.GA.TRACK_EVENT_CATEGORY.NOTIFICATION,
        M.GA.TRACK_EVENT_ACTION.ORDER_NUMBER_CLICK,
        GA_label
      );
    }
  });

  M.View.Order.OrderStatus.getDetailsLinkUrl = function(order) {
    var url = '/orders'
    if (order['replacement'] != true) {
      url = '/order/detail/';
      url += order['po_number'];
      url += '?ref=notificationctr';
      url += '&it_category=notification__number';
      url += '&it_id=' + order['button_text'].replace(/\s+/g, '_');
    }
    return url;
  };

  M.View.Order.OrderStatus.checkUserLoggedIn = function(url){
    return (M.loggedInUser.get('firstName') === null &&
        M.loggedInUser.get('userId') === 0)
  };

  M.View.Order.OrderStatus.getButtonClickUrl = function(order) {
    var url = order['CTA_url'];

    // In shipped orders the CTA URL is an external website.
    if (order['eventLabel'] !== 'Ready to Ship' && order['eventLabel'] !== 'In Transit') {
      url += '?ref=notificationctr';
      url += '&it_category=notification__button';
      url += '&it_id=' + order['button_text'].replace(/\s+/g, '_');
    }

    //if user not logged in, redirect to /login then CU3 for that BNPL order
    if (M.View.Order.OrderStatus.checkUserLoggedIn()){
      url = "/login?destination=" + url;
    }

    return url;
  };

  // Mapping from order status event labels to friendly text to
  // show to the user.
  M.View.Order.OrderStatus.friendlyTextMapping = {
    'Order Processing': 'we\'re processing your order',
    'Proof In Progress': 'your proof is in progress',
    'Awaiting Your Approval': 'your proof is ready for review',
    'Production In Progress': 'we\'re producing your order',
    'Shipped': 'your order has shipped!',
    'Complete': 'your order has been delivered!',
    'Needs Attention': 'your order is missing content',
    'Order Parked': 'finish personalizing your design',
    'Multiple Shipments': 'your order has shipped!',
    'Multiple Proofs': 'your order needs attention',
    'Download Ready': 'your file is ready to download',
    'Downloads Ready': 'your files are ready to download',
    'Sent to Guests': 'your invitation was sent to guests',
    'Ready to Ship': 'your order is awaiting carrier pickup',
    'In Transit': 'your order has shipped!'
  };

})(M, Backbone, jQuery, _);
